<template>
  <div class="payment-success-container">
    <div class="success-content">
      <!-- 成功图标 -->
      <div class="success-icon">
        <i class="el-icon-success"></i>
      </div>
      
      <!-- 成功提示 -->
      <h2 class="success-title">支付成功</h2>
      <p class="success-message">您的订单已支付成功，我们会尽快为您安排发货</p>
      
      <!-- 订单信息 -->
      <div class="order-info" v-if="orderNo">
        <div class="info-item">
          <span class="info-label">订单编号：</span>
          <span class="info-value">{{ orderNo }}</span>
        </div>
        <div class="info-item" v-if="orderAmount">
          <span class="info-label">支付金额：</span>
          <span class="info-value amount">¥{{ orderAmount }}</span>
        </div>
      </div>
      
      <!-- 操作按钮 -->
      <div class="action-buttons">
        <el-button type="primary" @click="goToProductList">继续购物</el-button>
        <el-button @click="goToHome">返回首页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 支付成功页面组件
 * 业务背景：用户完成支付后需要明确的成功反馈，展示订单信息并提供后续操作入口
 * 设计决策：使用清晰的视觉反馈（成功图标、提示文字），展示关键订单信息，提供继续购物和返回首页的快捷入口
 */
export default {
  name: "PaymentSuccess",
  data() {
    return {
      orderNo: '', // 订单编号
      orderAmount: '' // 订单金额
    };
  },

  /**
   * 组件创建时从路由参数或 sessionStorage 获取订单信息
   * 业务背景：支付成功后需要展示订单信息，但路由参数可能在刷新后丢失
   * 设计决策：优先从路由参数获取，如果没有则从 sessionStorage 获取，确保信息不丢失
   */
  created() {
    // 从路由参数获取订单信息
    const params = this.$route.params;
    if (params.orderNo) {
      this.orderNo = params.orderNo;
    }
    if (params.orderAmount) {
      this.orderAmount = params.orderAmount;
    }
    
    // 如果没有路由参数，尝试从 sessionStorage 获取
    if (!this.orderNo) {
      const orderData = sessionStorage.getItem('lastOrderInfo');
      if (orderData) {
        try {
          const orderInfo = JSON.parse(orderData);
          this.orderNo = orderInfo.orderNo || '';
          this.orderAmount = orderInfo.orderAmount || '';
        } catch (e) {
          console.error('解析订单信息失败:', e);
        }
      }
    }
  },

  methods: {
    /**
     * 跳转到商品列表页面
     * 业务背景：用户可能想继续购买其他商品
     * 设计决策：提供快捷入口，提升用户体验
     */
    goToProductList() {
      this.$router.push({
        name: 'ProductList'
      });
    },

    /**
     * 跳转到首页
     * 业务背景：用户可能想返回首页浏览其他内容
     * 设计决策：提供返回首页的快捷入口
     */
    goToHome() {
      this.$router.push({
        name: 'Homepage'
      });
    }
  }
};
</script>

<style scoped>
.payment-success-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
}

.success-content {
  background: #fff;
  border-radius: 12px;
  padding: 60px 40px;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  width: 100%;
}

.success-icon {
  margin-bottom: 30px;
}

.success-icon i {
  font-size: 80px;
  color: #67c23a;
}

.success-title {
  font-size: 28px;
  color: #333;
  margin-bottom: 15px;
  font-weight: 600;
}

.success-message {
  font-size: 16px;
  color: #666;
  margin-bottom: 40px;
  line-height: 1.6;
}

.order-info {
  background: #f5f7fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 40px;
  text-align: left;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  font-size: 16px;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-label {
  color: #666;
}

.info-value {
  color: #333;
  font-weight: 500;
}

.info-value.amount {
  color: #ff7452;
  font-size: 20px;
  font-weight: 600;
}

.action-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
}

.action-buttons .el-button {
  padding: 12px 40px;
  font-size: 16px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .success-content {
    padding: 40px 20px;
  }

  .success-icon i {
    font-size: 60px;
  }

  .success-title {
    font-size: 24px;
  }

  .success-message {
    font-size: 14px;
  }

  .action-buttons {
    flex-direction: column;
  }

  .action-buttons .el-button {
    width: 100%;
  }
}
</style>

